<template>
  <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
    <b-row>
      <b-col cols="8">
        <span
          style="color: white; text-align: left; font-size: 18px;"
        >แจ้งเตือนเหตุการณ์ในระบบ</span>
      </b-col>
      <b-col
        cols="4"
        class="d-flex align-items-center justify-content-end"
      >
        <a>
          <b-button
            :to="{ path: `/semcontrol-problem?wid=${$route.query.wid}`}"
            variant="danger"
            class="btn-icon"
            style="height:auto;"
          >
            <feather-icon
              icon="InfoIcon"
              size="24"
              class="mr-1"
            />
            <label style="color:white; font-size: 14px;">บันทึกข้อมูลไฟฟ้าขัดข้อง</label>
          </b-button>
        </a>
      </b-col>
    </b-row>
    <b-row style="padding-top:10px;">
      <b-col
        cols="12"
      >
        <b-table
          responsive
          :items="items"
          :fields="fields"
          thead-class="hidden_header"
        >
          <template
            #cell(icon)="data"
            class="icon"
          >
            <b-img
              :src="require('@/assets/images/icons/' + data.value + '.png')"
              height="32px"
            />
          </template>
          <template
            #cell(lastupdate)="data"
            class="icon"
          >
            <span style="color:gray">{{ data.value }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!-- <hr style="border-top: 1px solid #ffffff; margin:0"> -->

  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BImg, BButton,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BButton,
    BImg,
  },
  data() {
    return {
      ack: '',
      event: '',
      items: [],
      fields: [
        { key: 'icon', class: 'text-right' },
        { key: 'lastupdate', class: 'text-left' },
        { key: 'event', class: 'text-left' },
      ],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSemEvent()
    this.interval = setInterval(() => {
      this.getSemEvent()
    }, 10000)
  },
  methods: {
    getSemEvent() {
      axios
        .post('/getSemEventLog', { wid: this.$route.query.wid })
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },

  },
}
</script>
<style>
.hidden_header {
  display: none;
}
.table-responsive{
   font-size: 14px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}
</style>
